import "./promocodesTable.scss";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { AlertDialog } from "../modal";
import { useState } from "react";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";

const PromocodesTable = ({ rows }) => {
  const [dialogDetails, setDialogDetails] = useState({
    title: "Confirmation",
    body: "Do you still want to permanently delete this promo code?",
    primaryText: "Yes",
    cancelBtnText: "No",
    id:""
  });

  const [open, setOpen] = useState(false);

  const handlePrimaryClick = async () => {
    try {
      await deleteDoc(doc(db,"promoCodes",dialogDetails.id))
      setOpen(false)
    } catch (error) {
      alert("Failed to delete code -"+error)
    }
   
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteCode = async (id, code) => {
    setDialogDetails({
      title: "Confirmation",
      body:
        "Do you still want to permanently delete this '" + code + "' promo code?",
      primaryText: "Yes",
      cancelBtnText: "No",
      id:id,
    });
    setOpen(true);
  };
  return (
    <>
      <TableContainer component={Paper} className="pctable">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className="tableCell">Promocode ID</TableCell>
              <TableCell className="tableCell">Code</TableCell>
              <TableCell className="tableCell">Type</TableCell>
              <TableCell className="tableCell">Value</TableCell>
              <TableCell className="tableCell">Max Discount</TableCell>
              <TableCell className="tableCell">Min order value</TableCell>
              <TableCell className="tableCell">Maximun Usage</TableCell>
              <TableCell className="tableCell">Valid Till(11:59pm)</TableCell>
              <TableCell className="tableCell">Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.id}
                sx={{ cursor: "pointer" }}
                onClick={() => handleDeleteCode(row.id, row.code)}
              >
                <TableCell className="tableCell">{row.id}</TableCell>
                <TableCell className="tableCell">{row.code}</TableCell>
                <TableCell className="tableCell">
                  {row.type.toUpperCase()}
                </TableCell>
                <TableCell className="tableCell">
                  {row.type === "per" ? "" : "₹"}
                  {row.discount}
                  {row.type === "per" ? "%" : ""}
                </TableCell>
                <TableCell className="tableCell">
                  {row.type === "per"
                    ? `₹${row.maxDiscount}`
                    : "Not applicable"}
                </TableCell>
                <TableCell className="tableCell">₹{row.mov}</TableCell>
                <TableCell className="tableCell">{`${row.frequency} per user`}</TableCell>
                <TableCell className="tableCell">{row.validity}</TableCell>
                <TableCell className="tableCell">
                  <span className={`pcstatus ${row.status}`}>
                    {row.statusMessage}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <AlertDialog
        title={dialogDetails.title}
        body={dialogDetails.body}
        primaryBtnText={dialogDetails.primaryText}
        cancelBtnText={dialogDetails.cancelBtnText}
        open={open}
        handleClose={handleClose}
        primaryClick={handlePrimaryClick}
      />
    </>
  );
};

export default PromocodesTable;
